import ForecastCard from "./ForecastCard";
export default ForecastCard;
